'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RouteHelper = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RouteHelper = exports.RouteHelper = (_temp = _class = function () {
  function RouteHelper(context) {
    var _this = this;

    _classCallCheck(this, RouteHelper);

    this._fns = [];
    this.context = context;
    this.setState(null, window.location.href);
    context.router.listen(function (location) {
      _this.context.location = location;
      _this.setState(null, window.location.href);
    });
  }

  _createClass(RouteHelper, [{
    key: 'replace',
    value: function replace(query) {
      var newLocation = this.context.router.createLocation(this.context.location.pathname);
      newLocation.query = Object.assign(this.context.location.query, query);
      this.context.router.replace(newLocation);
    }
  }, {
    key: 'push',
    value: function push(url) {
      this.context.router.push(url);
    }
  }, {
    key: 'watch',
    value: function watch(watcher, callback) {
      this._fns.push({
        watcher: watcher,
        callback: callback
      });
    }
  }, {
    key: 'unwatch',
    value: function unwatch(watcher) {
      var index = this._fns.findIndex(function (cfg) {
        return cfg.watcher === watcher;
      });
      this._fns.splice(index, 1);
    }
  }, {
    key: 'setState',
    value: function setState(query, url) {
      var newState = {};
      if (url) {
        var u = _url2.default.parse(url, true);
        Object.assign(newState, u.query);
      }

      if (query) {
        Object.assign(newState, query);
      }

      try {
        var cfg = void 0;
        for (var i = 0, len = this._fns.length; i < len; i++) {
          cfg = this._fns[i];
          if (cfg.watcher(newState, this.state)) {
            cfg.callback(newState);
          }
        }
      } catch (e) {
        window.console.error(e);
      }
      this.state = newState;
    }
  }, {
    key: 'location',
    get: function get() {
      return this.context.location;
    }
  }]);

  return RouteHelper;
}(), _class.contextTypes = {
  location: _propTypes2.default.object,
  router: _propTypes2.default.object
}, _temp);


//////////////////
// WEBPACK FOOTER
// ./src/services/routeHelper/index.js
// module id = 128
// module chunks = 0